import { render, staticRenderFns } from "./comunicadosDetails.vue?vue&type=template&id=49d554f3&"
import script from "./comunicadosDetails.vue?vue&type=script&lang=js&"
export * from "./comunicadosDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports